<div class="row clearfix">
  <div class="col-md-12">
    <div class="card">
      <div class="header">
        <h2>Meta - Templates de Mensagem</h2>
        <ul class="header-dropdown">
          <li>
            <button mat-stroked-button type="button" [disabled]="isBusy" (click)="viewMetaTemplates()"
              matTooltip="Visualizar templates existentes na Meta">
              <mat-icon>visibility</mat-icon>
              <span> Ver Meta</span>
            </button>
          </li>
          <li>
            <button mat-stroked-button type="button" [disabled]="isBusy" (click)="importMetaTemplates()"
              matTooltip="Importar e atualizar templates existentes na Meta">
              <mat-icon>sync</mat-icon>
              <span> Sincronizar Meta</span>
            </button>
          </li>
        </ul>
      </div>
      <div class="body table-responsive">
        <mat-progress-bar *ngIf="isBusy" mode="indeterminate"></mat-progress-bar>
        <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover"
          style="width: 100%;">
          <thead>
            <tr>
              <th class="text-center">Nome</th>
              <th class="text-center" width="110">Idioma</th>
              <th class="text-center" width="140">Categoria</th>
              <th class="text-center" width="130">Status</th>
              <th class="text-center" width="120">Qualidade</th>
              <th class="text-center" width="140">Enviado em</th>
              <th class="text-center" width="140">Atualizado em</th>
              <th class="text-center" width="170"></th>
            </tr>
          </thead>
          <tbody *ngIf="models?.length != 0">
            <tr *ngFor="let model of models">
              <td>{{model.name}}</td>
              <td>{{model.language}}</td>
              <td>
                <span class="label" [ngClass]="typesService.getMetaMsgTemplateCategoryTypeColor(model.categoria)">
                  {{typesService.getMetaMsgTemplateCategoryTypeNome(model.categoria)}}
                </span>
              </td>
              <td>
                <span class="label" [ngClass]="typesService.getMetaMsgTemplateStatusTypeColor(model.status)">
                  {{typesService.getMetaMsgTemplateStatusTypeNome(model.status)}}
                </span>
              </td>
              <td>{{model.qualityScore}}</td>
              <td>{{model.submittedAt | date:'dd/MM/yyyy HH:mm'}}</td>
              <td>{{model.metaUpdatedAt | date:'dd/MM/yyyy HH:mm'}}</td>
              <td class="text-center">
                <button [disabled]="!isAllowed('Update')" mat-icon-button type="button" (click)="edit(model)"
                  matTooltip="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
                <button [disabled]="!isAllowed('Read')" mat-icon-button type="button" (click)="detail(model)"
                  matTooltip="Detalhes">
                  <mat-icon>description</mat-icon>
                </button>
                <button [disabled]="!isAllowed('Update') || !canPublish(model)" mat-icon-button type="button"
                  (click)="publishToMeta(model)" matTooltip="Enviar para revisão da Meta">
                  <mat-icon>cloud_upload</mat-icon>
                </button>
                <button *ngIf="canSendTest(model)" [disabled]="!isAllowed('Update')" mat-icon-button type="button"
                  (click)="openSendTest(model)" matTooltip="Envio teste">
                  <mat-icon>send</mat-icon>
                </button>
                <button [disabled]="!isAllowed('Delete')" mat-icon-button type="button" (click)="delete(model.id)"
                  matTooltip="Excluir">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="fixed-action-btn">
        <button [disabled]="!isAllowed('Create')" mat-fab color="primary" (click)="create()"
          matTooltip="Adicionar (F9)" matTooltipPosition="above">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<app-meta-msg-template-modal #modal (modalSave)="onResponse($event)"></app-meta-msg-template-modal>
<app-meta-msg-template-meta-list-modal #metaListModal></app-meta-msg-template-meta-list-modal>

<div bsModal #sendTestModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"
  [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="sendTemplate">
      <form [formGroup]="form" (ngSubmit)="sendTest()">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" (click)="cancelSendTest()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">Envio teste</h4>
        </div>

        <div class="modal-body">
          <div class="row clearfix">
            <div class="col-md-12">
              <mat-form-field class="full-width">
                <mat-label>Número alvo</mat-label>
                <input matInput formControlName="telefone" placeholder="Ex.: 5511999999999">
                <mat-error *ngIf="form.get('telefone')?.hasError('required')">
                  Informe o número alvo.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row clearfix" *ngIf="sendParametros.length > 0">
            <div class="col-md-12">
              <h5>Parâmetros</h5>
            </div>
            <div class="col-md-6" *ngFor="let parametro of sendParametros">
              <mat-form-field class="full-width">
                <mat-label>{{parametro.label}}</mat-label>
                <input matInput [formControlName]="getParametroControlName(parametro.key)"
                  [placeholder]="parametro.exemplo || parametro.key">
                <mat-hint *ngIf="parametro.exemplo">Ex.: {{parametro.exemplo}}</mat-hint>
                <mat-error *ngIf="form.get(getParametroControlName(parametro.key))?.hasError('required')">
                  Informe este parâmetro.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row clearfix">
            <div class="col-md-12">
              <h5>Preview</h5>
              <div class="well">
                <strong>{{sendTemplate.name}}</strong>
                <small class="text-muted">({{sendTemplate.language}})</small>

                <div *ngFor="let component of sendPreviewComponents" style="margin-top: 12px;">
                  <div class="text-muted">{{getComponentTitle(component)}}</div>
                  <div style="white-space: pre-wrap;">{{getPreviewText(component)}}</div>
                </div>

                <div *ngIf="sendPreviewComponents.length === 0" class="text-muted" style="margin-top: 12px;">
                  Template sem componentes de texto para preview.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" mat-stroked-button [disabled]="sendingTest" (click)="cancelSendTest()">
            Cancelar
          </button>
          <button type="submit" mat-raised-button color="primary" [disabled]="sendingTest">
            <mat-icon>send</mat-icon>
            <span> Enviar</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
